import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function LegalLayout({ title, lastUpdate, children }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50" data-testid="legal-page">
      <header className="bg-blue-600 text-white px-4 py-4 shadow-md">
        <div className="max-w-3xl mx-auto flex items-center gap-3">
          <Button
            onClick={() => navigate(-1)}
            variant="ghost"
            size="sm"
            className="text-white hover:bg-white/10"
            data-testid="legal-back-button"
          >
            <ArrowLeft className="w-4 h-4 mr-1" /> Indietro
          </Button>
          <div>
            <h1 className="text-xl font-outfit font-bold">{title}</h1>
            {lastUpdate && (
              <p className="text-xs text-white/80">Ultimo aggiornamento: {lastUpdate}</p>
            )}
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-8">
        <article className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 prose prose-slate max-w-none">
          {children}
        </article>
        <div className="text-center mt-6">
          <Button onClick={() => navigate('/home')} variant="outline" data-testid="legal-home-button">
            Torna alla home
          </Button>
        </div>
      </main>
    </div>
  );
}
